import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import api from "./services/API"
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.use(api);
Vue.use(VueCookies);

new Vue({
  router,
  store,
  data:{
    //
  },
  render: h => h(App)
}).$mount('#app')
